/**
 * @generated SignedSource<<a6355b196306984f90625ebbd7763e8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type IndividualStudentReportRoadmapOverallQuery$variables = {
  roadmapId: string;
  studentId: string;
};
export type IndividualStudentReportRoadmapOverallQuery$data = {
  readonly skillStatesByStudentId: ReadonlyArray<{
    readonly id: string;
    readonly skill: {
      readonly code: string | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly targetSkills: ReadonlyArray<{
        readonly id: string;
        readonly targetSkillType: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly skillAssessment: {
      readonly id: string;
      readonly score: number;
    } | null | undefined;
    readonly skillSubstate: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly skillState: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  }>;
};
export type IndividualStudentReportRoadmapOverallQuery = {
  response: IndividualStudentReportRoadmapOverallQuery$data;
  variables: IndividualStudentReportRoadmapOverallQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "roadmapId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "studentId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "targetGroupId",
            "variableName": "roadmapId"
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      },
      {
        "kind": "Variable",
        "name": "studentId",
        "variableName": "studentId"
      }
    ],
    "concreteType": "StudentSkillNode",
    "kind": "LinkedField",
    "name": "skillStatesByStudentId",
    "plural": true,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillNode",
        "kind": "LinkedField",
        "name": "skill",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  {
                    "items": [
                      {
                        "kind": "Variable",
                        "name": "targetGroupIds.0",
                        "variableName": "roadmapId"
                      }
                    ],
                    "kind": "ListValue",
                    "name": "targetGroupIds"
                  }
                ],
                "kind": "ObjectValue",
                "name": "filter"
              }
            ],
            "concreteType": "TargetSkillNode",
            "kind": "LinkedField",
            "name": "targetSkills",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetSkillTypeNode",
                "kind": "LinkedField",
                "name": "targetSkillType",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillSubstateNode",
        "kind": "LinkedField",
        "name": "skillSubstate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillStateNode",
            "kind": "LinkedField",
            "name": "skillState",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "showCurrentYearAssessmentsOnly",
            "value": true
          }
        ],
        "concreteType": "StudentSkillAssessmentNode",
        "kind": "LinkedField",
        "name": "skillAssessment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "score",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": "skillAssessment(showCurrentYearAssessmentsOnly:true)"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "IndividualStudentReportRoadmapOverallQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "IndividualStudentReportRoadmapOverallQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "5659b6bd55df6df98e0599b6d4f6de07",
    "id": null,
    "metadata": {},
    "name": "IndividualStudentReportRoadmapOverallQuery",
    "operationKind": "query",
    "text": "query IndividualStudentReportRoadmapOverallQuery(\n  $studentId: ID!\n  $roadmapId: ID!\n) {\n  skillStatesByStudentId(studentId: $studentId, filter: {targetGroupId: $roadmapId}) {\n    id\n    skill {\n      id\n      code\n      name\n      targetSkills(filter: {targetGroupIds: [$roadmapId]}) {\n        id\n        targetSkillType {\n          id\n          name\n        }\n      }\n    }\n    skillSubstate {\n      id\n      name\n      skillState {\n        id\n        name\n      }\n    }\n    skillAssessment(showCurrentYearAssessmentsOnly: true) {\n      score\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ebdc604f28c7e11955f2120d5f802ef";

export default node;
